import api from 'api';

export const loadResolutions = api('POST /api/gallery/filters/resolutions');
export const loadRatios = api('POST /api/gallery/filters/ratios');

export const loadCreatedBy = api('POST /api/gallery/filters/created-by');
export const loadRequestedBy = api('POST /api/gallery/filters/requested-by');
export const loadDesigners = api('POST /api/gallery/filters/authors');

export const loadSizes = api('POST /api/gallery/filters/sizes');
export const loadMediaTypes = api('POST /api/gallery/filters/media-types');
export const loadCreativeTypes = api(
  'POST /api/gallery/filters/creative-types'
);
export const loadNetworks = api('POST /api/gallery/filters/networks');
export const loadGenres = api('POST /api/gallery/filters/genres');
export const loadApplications = api('POST /api/gallery/filters/applications');
export const loadOrientations = api('POST /api/gallery/filters/orientations');
export const loadLanguages = api('POST /api/gallery/filters/languages');
export const loadStatuses = api('POST /api/gallery/filters/statuses');
export const loadOS = api('POST /api/gallery/filters/os');
export const loadEnhancers = api('POST /api/gallery/filters/enhancers');
export const loadChannels = api('POST /api/gallery/filters/channels');
export const loadIncludedTags = api('POST /api/gallery/filters/included-tags');
export const loadExcludedTags = api('POST /api/gallery/filters/excluded-tags');
export const loadAITaggingStatus = api(
  'GET /api/gallery/filters/ai-tagging-status'
);
export const loadAITags = api('GET /api/gallery/filters/ai-tags');
export const loadComments = api('POST /api/gallery/filters/comments');
export const loadFilterBy = api('POST /api/gallery/filters/filter-by');
export const loadConceptFamilies = api(
  'POST /api/gallery/filters/concept-families'
);
export const loadUsedInAds = api('POST /api/gallery/filters/used-in-ads');
export const loadUsedInAffiliates = api(
  'POST /api/gallery/filters/used-in-affiliates'
);
export const loadBusinessPartners = api(
  'GET /api/gallery/filters/business-partners'
);
export const loadFilterWith = api('GET /api/gallery/filters/shared-with');
export const loadIsNew = api('GET /api/gallery/filters/is-new');
export const loadPromoCodes = api('POST /api/gallery/filters/promo-codes');
export const loadOutsourceStudio = api(
  'GET /api/gallery/filters/outsource-studios'
);
export const loadExclusiveForAffiliates = api(
  'GET /api/gallery/filters/exclusive-for-affiliates'
);
export const loadIncludeYTLink = api(
  'GET /api/gallery/filters/include-yt-link'
);
export const loadTested = api('GET /api/gallery/filters/tested');
export const loadAIGenerated = api('GET /api/gallery/filters/ai-generated');
export const loadProductionTypes = api(
  'GET /api/gallery/filters/production-types'
);
